import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import styled from 'styled-components';
import UICopyButton from 'UIComponents/button/UICopyButton';
import Small from 'UIComponents/elements/Small';
import UITileSection from 'UIComponents/tile/UITileSection';
import { theme } from '../../../utils/Styling';
import UsageTracker from '../../../utils/UsageTracker';
const TileSection = styled(UITileSection).withConfig({
  displayName: "CopyToClipboardButton__TileSection",
  componentId: "obzhq0-0"
})(["padding:1px;:hover{background-color:", ";}"], theme.colors.CALYPSO_LIGHT);
const CopyButton = styled(UICopyButton).withConfig({
  displayName: "CopyToClipboardButton__CopyButton",
  componentId: "obzhq0-1"
})(["text-decoration:none !important;text-align:left !important;font-weight:500 !important;color:", " !important;"], theme.colors.OBSIDIAN);

const CopyToClipboardButton = ({
  shareUrl,
  title,
  description,
  trackerExtras = {},
  onClick
}) => {
  return /*#__PURE__*/_jsx(TileSection, {
    children: /*#__PURE__*/_jsxs(CopyButton, {
      hint: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.shareThis.hint"
      }),
      onClick: () => {
        UsageTracker.track('interaction', Object.assign({
          action: 'share-url-copied',
          href: shareUrl
        }, trackerExtras));
        if (onClick) onClick();
      },
      tooltipPlacement: "bottom",
      use: "transparent",
      value: shareUrl,
      children: [/*#__PURE__*/_jsx("div", {
        children: title
      }), /*#__PURE__*/_jsx(Small, {
        className: "m-left-0",
        use: "help",
        children: description
      })]
    })
  });
};

export default CopyToClipboardButton;